import React from 'react';
import PropTypes from 'prop-types';

import { Container, SeloPromocao } from './styles';
import { formatFloat, produtoEmPromocao, valorVendaProduto } from '../../../../util/functions';

function PrecoProduto(props) {
  PrecoProduto.propTypes = {
    produto: PropTypes.object,
  };

  const { produto } = props;

  return (
    <Container>
      <h2>{`R$ ${formatFloat(valorVendaProduto(produto), 2)}`}</h2>
      {produtoEmPromocao(produto) ? <SeloPromocao>Promoção</SeloPromocao> : null}
    </Container>
  );
}

export default PrecoProduto;
